export default __webpack_public_path__ + "static/media/Selo.5f3c1818.svg";